import type { PurchasePlace, PurchaseType } from "~/feature/Analytics/ga/recommendations/types";
import { format, getCsrfValue } from "../../api/ApiHelper";
import { type LineItem } from "../../Cart/models/CartData";
import { resolveApiUrl } from "../../utils/url/urlResolver";
import type { ProductDescriptor } from "~/feature/ProductDescriptor/v1/types";
import { getCurrentBrowserTimezone } from "~/utils/dateUtils";

interface AddToQuoteApiItem {
  productCode: string;
  packageSize?: number;
  packageCode: string;
  quantity: number;
  netPrice: number;
  priceUnit: number;
  comment?: string;
  internalComment?: string;
  selectedDeliveryDate: string;
  primaryWarehouseCode: string;
  offerPrice?: number;
  targetPrice?: number;
  minimumSellingPrice?: number;
  recommendedSellingPrice?: number;
  fifteenDigit: boolean;
  priceReference?: string;
}

interface AddToQuoteItem {
  productCode: string;
  packageSize?: number;
  packageCode: string;
  quantity: number;
  /**
   * Needs to be per piece or BE freaks out
   * TODO: Update BE to accept per {unitPrice} pieces
   */
  netPrice: number;
  priceUnit: number;
  comment?: string;
  internalComment?: string;
  selectedDeliveryDate: Date;
  primaryWarehouseCode: string;
  offerPrice?: number;
  targetPrice?: number;
  /**
   * Needs to be per piece or BE freaks out
   * TODO: Update BE to accept per {unitPrice} pieces
   */
  msp?: number;
  /**
   * Needs to be per piece or BE freaks out
   * TODO: Update BE to accept per {unitPrice} pieces
   */
  rsp?: number;
  fifteenDigit: boolean;
  priceReference: string;
}

function transform(item: AddToQuoteItem): AddToQuoteApiItem {
  return {
    ...item,
    selectedDeliveryDate: format(item.selectedDeliveryDate),
    // TEMP CHANGE - add new line character to internal comment
    internalComment: item.internalComment ? item.internalComment + "\n" : "",
  };
}

export function fromLineItem(data: LineItem, product: ProductDescriptor): AddToQuoteItem {
  return {
    productCode: product.base.code,
    packageSize: data.packSize,
    packageCode: data.packCode,
    quantity: data.quantity,
    netPrice: data.netPrice?.value ?? 0,
    priceUnit: data.netPrice?.unit ?? 1,
    comment: data.comment,
    selectedDeliveryDate: data.deliveryDate || new Date(),
    // estimatedDeliveryDate: (data.edd && data.edd.type === 'estimate') ? data.edd.date : undefined,
    primaryWarehouseCode: data.primaryWarehouseCode,
    fifteenDigit: product.isMultiPrice || false,
    priceReference: data.priceReference,

    msp: data.msp ? data.msp.value : undefined,
    rsp: data.rsp ? data.rsp.value : undefined,
    internalComment: data.internalComment,
    offerPrice: data.offerPrice ? data.offerPrice.value : undefined,
    targetPrice: data.targetPrice ? data.targetPrice.value : undefined,
  };
}

const apiUrl = resolveApiUrl("/quote/add/bulk");

export function sendAddToQuote(
  data: AddToQuoteItem | AddToQuoteItem[],
  context?: { recommendationType?: PurchaseType; recommendationPlace?: PurchasePlace },
) {
  const arrayData = Array.isArray(data) ? data : [data];
  const body = {
    items: arrayData.map(transform),
    userTimeZone: getCurrentBrowserTimezone(),
  };

  const packageToCartForm = JSON.stringify(body);

  return fetch(apiUrl, {
    body: packageToCartForm,
    cache: "no-cache",
    credentials: "same-origin",
    method: "POST",
    mode: "cors",
    headers: {
      dataType: "json",
      "content-type": "application/json",
      CSRFToken: getCsrfValue(),
    },
    redirect: "follow",
  }).then((result) => {
    window.SCHA.updateMinicart?.();
    return result;
  });
}
